import * as React from "react";
import EdButton from "../../../generic/edButton";
import ObCheckbox from "../generic/obCheckbox";
import { AEqConvertPos } from "../../../service/orderBook/obApiService";
import ObProductTypeSelect from "./obProductTypeSelect";
import ObAssetDetailPopup from "../generic/obAssetDetailPopup";
import ObToastMessPopup from "../generic/obToastMessPopup";
import SlideUpPopup from "../../../generic/slideUpPopup";
import ee from "../../../utils/eventEmitter";
import ObTradeTabContent from "./obTradeTabContent";
import { backButtonValue } from "../obJsXConstants";
import "../../../../assets/scss/components/generic/layout/layoutMob.scss";
import "../../../../assets/scss/components/toc/orderBook/obConvertPositions/obConvertPositionMob.scss";
import { IListObj } from "../../../types/genericTypes";

export interface IObEquityConvertMobProps {
	data: Array<any>;
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
}

const ObEquityConvertMob: React.FC<IObEquityConvertMobProps> = (props) => {
	const [tradeData, setTradeData] = React.useState(
		props.data.map((data, index) => {
			return { ...data, id: index, isSelected: false };
		})
	);

	const [isAllDataSelected, setIsAllDataSelected] = React.useState(false);

	const [showConvertPosition, setShowConvertPosition] = React.useState(false);

	// show convertion error popup
	const [conErrorPopupMsg, setConErrorPopupMsg] = React.useState<string>();

	const [isProcessing, setIsProcessing] = React.useState(false);

	// total qty of selected rows
	const totalSelectedQty = tradeData.reduce((a, b) => {
		if (b.isSelected) {
			return a + +b.qty;
		} else {
			return a;
		}
	}, 0);

	const navigationDropdownOptions: Array<IListObj> = [
		{ value: "NRML", display: "NRML" },
		{ value: "MIS", display: "MIS" },
		{ value: "MTF", display: "MTF" },
		{ value: "BO", display: "BO" },
		{ value: "CO", display: "CO" }
	];

	let selectedPrdCode: string;

	let ordConvertedSuccList: Array<string> = [],
		ordConvertedFailList: Array<{ error: any; index: number }> = [],
		OrdsListToConvert: Array<string> = [];
	// runs after all convert api response
	function convertCallback(res: any, index: number) {
		if (res.data) {
			// if success
			ordConvertedSuccList.push(res.data);
		} else {
			// if error
			ordConvertedFailList.push({ error: res.error, index });
		}

		// when we get all the responses
		if (ordConvertedSuccList.length + ordConvertedFailList.length === OrdsListToConvert.length) {
			setIsProcessing(false);

			if (ordConvertedSuccList.length === OrdsListToConvert.length) {
				// when all the converted successfully
				ee.emit("showToast", { message: `Success - ${totalSelectedQty} qty (SYMBOL) converted to ${selectedPrdCode}`, color: "success" }); //show toast message
			} else if (ordConvertedFailList.length === OrdsListToConvert.length) {
				// when all request failed
				ee.emit("showToast", {
					message: (
						<span>
							Could not convert selected positions{" "}
							<button className="hyper_link" onClick={() => setConErrorPopupMsg("lorem ipsum")}>
								know more
							</button>
						</span>
					),
					color: "error"
				}); //show toast message
			} else {
				// partial conversion
				ee.emit("showToast", {
					message: `Could not convert ${ordConvertedFailList.length} / ${OrdsListToConvert.length} selected positions`,
					color: "error"
				}); //show toast message
			}
		}
	}

	function onConvertPosition(selectedRadio: string) {
		setIsProcessing(true);
		selectedPrdCode = selectedRadio;

		// call api for all selected rows
		tradeData.forEach((rw: any, index: number) => {
			if (rw.isSelected) {
				OrdsListToConvert.push(rw.ordID);
				AEqConvertPos((res: any) => convertCallback(res, index), {
					nstOID: rw.ordID,
					flID: rw.flID,
					prdCode: rw.prdCode,
					prdCodeCh: selectedRadio,
					exc: rw.exc,
					ordTyp: rw.ordTyp
				});
			}
		});
	}

	function obEqtradeRowSelection(index: number) {
		// if checkbox of any row is selected
		if (index >= 0) {
			// copy the data
			const data = [...tradeData];
			// get the row
			const row = { ...data[index] };
			// invert the status
			row.isSelected = !tradeData[index].isSelected;
			// put the updated row back in data
			data[index] = row;
			// set the state
			setTradeData(data);

			// set the value of all selected checkbox
			data.every((row) => row.isSelected === true) ? setIsAllDataSelected(true) : setIsAllDataSelected(false);
		}
		// if all clicked on all selected checkbox
		else if (index === -1) {
			// copy the data
			let data = [...tradeData];
			// loop over the data
			// If isAllDataSelected is true, then set every row to false
			// else if isAllDataSelected is false, then set every row to true
			data = data.map((row) => ({ ...row, isSelected: !isAllDataSelected }));

			setTradeData(data);

			// invert the state of isAllDataSelected
			setIsAllDataSelected(!isAllDataSelected);
		}
	}

	return (
		<section className="outer_container eq_conv_mob_wrap">
			<section className="ob_container lyCont">
				{/* {showToast && <ObToastMessage {...showToast} />} */}
				<section className="ob_view_mob ly_view_mob ">
					<div className="ob_title ly_title ">
						<EdButton value={backButtonValue} btnTyp="link" onClick={props.onBackClick} className="icon_button" />
					</div>
					<div className="ob_content_mob ly_content_mob ">
						<div className="ob_eq_convert_con">
							<div className="select_hdr">
								<div className="check_box">
									<ObCheckbox name="eqTradeSelect" checked={isAllDataSelected} onChange={() => obEqtradeRowSelection(-1)}>
										Select All
									</ObCheckbox>
								</div>
							</div>
							<ul className="ob_conver_tbl">
								{tradeData.map((data, index) => (
									<ObTradeTabContent
										isSelected={data.isSelected}
										onSelect={() => obEqtradeRowSelection(index)}
										showCheckbox={true}
										tooltipTxt={ordConvertedFailList.find((failObj) => failObj.index === index)?.error.errMsg}
										key={index}
										data={data}
									/>
								))}
							</ul>
							<div className="next_button_mob">
								<EdButton className="next_btn" value="Next" btnTyp="primary" onClick={() => setShowConvertPosition(true)} />
							</div>
						</div>
					</div>
				</section>
			</section>
			{showConvertPosition && (
				<SlideUpPopup closePopup={() => setShowConvertPosition(false)}>
					<ObProductTypeSelect
						list={navigationDropdownOptions}
						numOfQty={totalSelectedQty}
						onConvertPosition={onConvertPosition}
						isProcessing={isProcessing}
						onClose={() => setShowConvertPosition(false)}
					/>
				</SlideUpPopup>
			)}

			{conErrorPopupMsg && (
				<ObAssetDetailPopup>
					<ObToastMessPopup
						title="Error in Conversion"
						subtitle="classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of “de Finibus Bonorum et Malorum” (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance."
						buttonValue="Okay"
						btnTyp="blue-link"
						onBackClick={() => setConErrorPopupMsg(undefined)}
						onToastBtnClick={() => setConErrorPopupMsg(undefined)}
					/>
				</ObAssetDetailPopup>
			)}
		</section>
	);
};

export default ObEquityConvertMob;
